/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyConsumableReturnBillItem from './pharmacy-consumable-return-bill-item';
import PharmacyConsumableReturnBillItemDetail from './pharmacy-consumable-return-bill-item-detail';
import PharmacyConsumableReturnBillItemUpdate from './pharmacy-consumable-return-bill-item-update';
import PharmacyConsumableReturnBillItemDeleteDialog from './pharmacy-consumable-return-bill-item-delete-dialog';

const PharmacyConsumableReturnBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyConsumableReturnBillItem />} />
    <Route path="new" element={<PharmacyConsumableReturnBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyConsumableReturnBillItemDetail />} />
      <Route path="edit" element={<PharmacyConsumableReturnBillItemUpdate />} />
      <Route path="delete" element={<PharmacyConsumableReturnBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyConsumableReturnBillItemRoutes;
